// extracted by mini-css-extract-plugin
export default {"spinner":"default_spinner__tRCC3"};